import AppForm from "components/AppForm/AppForm";
import CrudPage from "components/CrudPage/CrudPage";
import { withRemoteDataAndSpinner } from "hoc/withRemoteDataAndSpinner";
import withRouter from "hoc/withRouter";
import { useLoadAll } from "hooks/useLoadAll";
import { useGetBranches } from "hooks/useGetBranches";
import inputTypeEnum from "enums/inputTypes";
import { snack } from "components/Snack/Snack";
import stationsService from "services/admin/stationsService";

interface StationFormProps {
  router: any;
  data: any;
}

const StationForm = ({ router, data }: StationFormProps) => {
  const {
    navigate,
    params: { id },
  } = router;
  const { station } = data;

  const { data: branchesResponse } = useGetBranches({
    orgID: localStorage.getItem("orgID") || "",
  });
  const branches = (branchesResponse as any)?.data || [];

  const fieldsWithData = [
    {
      key: "name",
      label: "Название станции",
      required: true,
      inputType: inputTypeEnum.text,
    },
    // {
    //   key: "code",
    //   label: "Код станции",
    //   inputType: inputTypeEnum.text,
    // },
    // {
    //   key: "city",
    //   label: "Город",
    //   inputType: inputTypeEnum.text,
    // },
    // {
    //   key: "branchID",
    //   label: "Филиал",
    //   inputType: inputTypeEnum.select,
    //   options: branches.map((b: any) => ({ id: b.id, name: b.name })),
    // },
  ];

  const onSubmit = async (formValues: any) => {
    try {
      if (station) {
        await stationsService.put(id, formValues);
        snack("Станция обновлена успешно!");
      } else {
        await stationsService.post(formValues);
        snack("Станция создана успешно!");
      }

      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (ex) {
      console.error(ex);
    }
  };

  return (
    <CrudPage title={station ? "Редактирование станции" : "Создание станции"}>
      <AppForm onSubmit={onSubmit} data={station} fields={fieldsWithData}></AppForm>
    </CrudPage>
  );
};
export default withRouter(
  withRemoteDataAndSpinner(StationForm, (router: any) => {
    let requests: any = {};
    if (router.params.id) {
      requests["station"] = () => stationsService.get(router.params.id);
    }
    return useLoadAll(requests);
  }),
);
